import * as CryptoJS from 'crypto-js'

import Resources from './resourses';
import { BehaviorSubject, Observable } from 'rxjs';
export default class Utils {
  // convert to SHA256
  static encryptIntoSha256(text: string): any {

    return CryptoJS.SHA256(text).toString();
  }

  static removeSessionStorageValuesineditDetailsPage() { // remove session items
    sessionStorage.removeItem(Resources.SessionStorageKeys.NetzeroAPI);
    sessionStorage.removeItem(Resources.SessionStorageKeys.EVCurrentData);
    sessionStorage.removeItem(Resources.SessionStorageKeys.IsNoQuotes);
    sessionStorage.removeItem(Resources.SessionStorageKeys.EVUpdateDetails);
    sessionStorage.removeItem(Resources.SessionStorageKeys.PreferenceData);
    sessionStorage.removeItem(Resources.SessionStorageKeys.FromEditDetails);
    sessionStorage.removeItem(Resources.SessionStorageKeys.FromExceptionalFlow);
    sessionStorage.removeItem(Resources.SessionStorageKeys.BackFromSwitchPage);
    sessionStorage.removeItem(Resources.SessionStorageKeys.QuoteKey);
    sessionStorage.removeItem(Resources.SessionStorageKeys.QuotesData);
    sessionStorage.removeItem(Resources.SessionStorageKeys.FilterOnLoad);
    sessionStorage.removeItem(Resources.SessionStorageKeys.SupplierToSwitch);
    sessionStorage.removeItem(Resources.SessionStorageKeys.PaymentID);
    sessionStorage.removeItem(Resources.SessionStorageKeys.PaidTosave);
    sessionStorage.removeItem(Resources.SessionStorageKeys.FuturePrice);
    sessionStorage.removeItem(Resources.SessionStorageKeys.PersonalDetails);
    sessionStorage.removeItem(Resources.SessionStorageKeys.MonthlyYearltToggle);
    sessionStorage.removeItem(Resources.SessionStorageKeys.IsUserSubscribed);

    sessionStorage.removeItem(Resources.SessionStorageKeys.IsSmart);
    sessionStorage.removeItem(Resources.SessionStorageKeys.IsNotNow);
    // sessionStorage.removeItem(Resources.SessionStorageKeys.IsQuotaReached);
    sessionStorage.removeItem(Resources.SessionStorageKeys.IsDismissNotSmartMeter);
    sessionStorage.removeItem(Resources.SessionStorageKeys.IsDismissQuotaLimit);
  }

  static removeSessionStorageValuesinThankyouPage() { // remove session items
    sessionStorage.removeItem(Resources.SessionStorageKeys.CurrentUsage);
    sessionStorage.removeItem(Resources.SessionStorageKeys.NetzeroAPI);
    sessionStorage.removeItem(Resources.SessionStorageKeys.EVCurrentData);
    sessionStorage.removeItem(Resources.SessionStorageKeys.EVUpdateDetails);
    sessionStorage.removeItem(Resources.SessionStorageKeys.PreferenceData);
    sessionStorage.removeItem(Resources.SessionStorageKeys.FromEditDetails);
    sessionStorage.removeItem(Resources.SessionStorageKeys.FromExceptionalFlow);
    sessionStorage.removeItem(Resources.SessionStorageKeys.ExceptionData);
    sessionStorage.removeItem(Resources.SessionStorageKeys.EditDetailsData);
    sessionStorage.removeItem(Resources.SessionStorageKeys.BackFromSwitchPage);
    sessionStorage.removeItem(Resources.SessionStorageKeys.QuoteKey);
    sessionStorage.removeItem(Resources.SessionStorageKeys.QuotesData);
    sessionStorage.removeItem(Resources.SessionStorageKeys.FilterOnLoad);
    sessionStorage.removeItem(Resources.SessionStorageKeys.SupplierToSwitch);
    sessionStorage.removeItem(Resources.SessionStorageKeys.PaymentID);
    sessionStorage.removeItem(Resources.SessionStorageKeys.SelectedAddress);
    sessionStorage.removeItem(Resources.SessionStorageKeys.PaidTosave);
    sessionStorage.removeItem(Resources.SessionStorageKeys.IsChecked);
    sessionStorage.removeItem(Resources.SessionStorageKeys.UserInfo);
    sessionStorage.removeItem(Resources.SessionStorageKeys.CurrentAddressId);
    sessionStorage.removeItem(Resources.SessionStorageKeys.IsNoQuotes);
    localStorage.removeItem(Resources.SessionStorageKeys.QuotesData);
    sessionStorage.removeItem(Resources.SessionStorageKeys.AutoAlertPostcode)
    sessionStorage.removeItem(Resources.SessionStorageKeys.FuturePrice);
    sessionStorage.removeItem(Resources.SessionStorageKeys.IsBankDetailsPresent);
    sessionStorage.removeItem(Resources.SessionStorageKeys.SignUpWithoutQuotes);
    sessionStorage.removeItem(Resources.SessionStorageKeys.IsAutoSwitchFlow);
    sessionStorage.removeItem(Resources.SessionStorageKeys.DnoId);
    sessionStorage.removeItem(Resources.SessionStorageKeys.CurrentSuppData);
    sessionStorage.removeItem(Resources.SessionStorageKeys.IsAddressForQuoteLink);
    sessionStorage.removeItem(Resources.SessionStorageKeys.IsAutoSwitchFlowQuotes);
    sessionStorage.removeItem(Resources.SessionStorageKeys.IsAutoAlertAddAddressFlow);
    sessionStorage.removeItem(Resources.SessionStorageKeys.IsErrorflow);
    sessionStorage.removeItem(Resources.SessionStorageKeys.MoveInDate);
    // localStorage.clear();
  }

  static encodeData(data: any): string {

    return '';
  }

  static decodeData(data: string): any {
    return '';
  }

  static formatDate(date: any) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    return [year, month, day].join('-');
  }

  static formatDateSec(date: any) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    let hours = '' + d.getHours();
    let minutes = '' + d.getMinutes();
    let seconds = '' + d.getSeconds();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    if (hours.length < 2) {
      hours = '0' + hours;
    }
    if (minutes.length < 2) {
      minutes = '0' + minutes;
    }
    if (seconds.length < 2) {
      seconds = '0' + seconds;
    }

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  static formatDay(day) {
    var day1 = day; // Initialize with default value
    if (day.length < 2) {
      day1 = '0' + day;
    }
    return day1;
  }

  static formatMonth(month) {
    var month1 = month; // Initialize with default value
    if (month.length < 2) {
      month1 = '0' + month;
    }
    return month1;
  }

  // JSON to query string
  static jsonToQueryString(json: any): string {
    return '?' +
      Object.keys(json).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
      }).join('&');
  }

  /**
   * @description Convert string to upper camel case
   * @param value string 
   * @param target string
   * @returns string
   */
  static toUpperCamelCase(value: string, target: string): string {
    return value.split(target).map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join('');
  }

  /**
   * @description value convert to absolute value
   * @param value number
   * @returns number
   */
  static absoluteValue(value: number): number {
    return Math.abs(value);
  }

  /**
   * @description Extracts the domain from an email string
   * @param email string
   * @returns string
   */
  static getEmailDomain(email: string): string {
    const atIndex = email.indexOf('@');
    if (atIndex === -1) {
      return email; // Return the original string if '@' is not found
    }
    return email.substring(atIndex + 1);
  }
}